import { jsx, jsxs } from 'react/jsx-runtime';
import { useRef, useState, useEffect, useCallback } from 'react';
import { useHoverDirty, useClickAway } from 'react-use';
import '../../../contexts/MenuContext/index.mjs';
import { AvailableLanguages } from '../../../contexts/MenuContext/mapping.mjs';
import '../../StaticModal/index.mjs';
import { Frame, ButtonWrap, CustomLinkButton, LanguageKey, LanguageValue } from './LanguageFrame.styles.mjs';
import './translations/index.mjs';
import { buildLanguageLink } from './utils/buildLanguageLink.mjs';
import { Language } from '../../../types/constants.mjs';
import { useMenu } from '../../../contexts/MenuContext/context.mjs';
import { StaticModal } from '../../StaticModal/StaticModal.mjs';
import EN_TRANSLATION from './translations/en.json.mjs';
"use strict";
const DisplayLocale = {
  [Language.En]: "en",
  [Language.Ar]: "ar",
  [Language.De]: "de",
  [Language.El]: "el",
  [Language.Es]: "es",
  [Language.Fr]: "fr",
  [Language.It]: "it",
  [Language.Ja]: "ja",
  [Language.Pt]: "pt",
  [Language.Zh]: "zh",
  [Language.Tw]: "tw"
};
const LanguageFrame = ({
  onLanguageChange,
  open,
  onClose
}) => {
  const {
    deployedLanguages,
    language,
    storeId
  } = useMenu();
  const ref = useRef(null);
  const name = useRef(null);
  const isHovering = useHoverDirty(name);
  const [, setShowPopOver] = useState(false);
  useEffect(() => {
    if (name.current) {
      const displayPopover = name.current.offsetWidth < name.current.scrollWidth;
      if (displayPopover && isHovering) {
        setShowPopOver(true);
      } else if (displayPopover && !isHovering) {
        setShowPopOver(false);
      }
    }
  }, [isHovering]);
  const handleClose = useCallback(() => {
    onClose();
  }, [onClose]);
  useClickAway(ref, event => {
    let canClose = true;
    if (event.target instanceof Element) {
      const oneTrustElId = "onetrust-banner-sdk";
      const isOneTrustEl = event.target.id === oneTrustElId || !!event.target.closest(`#${oneTrustElId}`);
      if (isOneTrustEl) {
        canClose = false;
      }
    }
    if (canClose) {
      handleClose();
    }
  }, ["click"]);
  return /* @__PURE__ */jsx(StaticModal, {
    show: !!open,
    width: deployedLanguages.includes(Language.Tw) ? 245 : 225,
    children: /* @__PURE__ */jsx(Frame, {
      ref,
      children: /* @__PURE__ */jsx(ButtonWrap, {
        children: Object.entries(AvailableLanguages).map(([key, val]) => {
          if (deployedLanguages.includes(key)) {
            const href = buildLanguageLink(storeId, key);
            if (!href) return null;
            return /* @__PURE__ */jsxs(CustomLinkButton, {
              anchor: true,
              $active: key === language,
              variant: "link",
              href,
              onClick: e => {
                onLanguageChange?.(e, href, key);
                handleClose();
              },
              "data-test-id": `language-wrap${key === language ? "-active" : ""}`,
              children: [/* @__PURE__ */jsx(LanguageKey, {
                "data-test-id": `language-key-${DisplayLocale[key]}`,
                children: DisplayLocale[key]
              }), /* @__PURE__ */jsx(LanguageValue, {
                "data-test-id": "language-value",
                children: EN_TRANSLATION[val]
              })]
            }, key);
          } else {
            return null;
          }
        })
      })
    })
  });
};
export { DisplayLocale, LanguageFrame };
//# sourceMappingURL=LanguageFrame.mjs.map
